export default __webpack_public_path__ + "static/media/clear.4586f7ed.svg";